import type { MailboxInfo } from "owa-client-types";
import { action } from "satcheljs";

export interface OnRefreshAppBarDataActionMessage {
    mailboxInfo: MailboxInfo | undefined;
}
const onRefreshAppBarData: (mailboxInfo?: MailboxInfo) => OnRefreshAppBarDataActionMessage = action("onRefreshAppBarData", (mailboxInfo?: MailboxInfo): OnRefreshAppBarDataActionMessage => ({
    mailboxInfo,
}));

export default onRefreshAppBarData;
